'use strict';

// Comportement JavaScript pour le bloc de timeline sur la page d'accueil.
// Il initialise deux sliders synchronisés (contenu + barre des années)
// et applique plusieurs correctifs pour l'accessibilité (aria-hidden, aria-disabled, etc.).
DJ.addBehavior('home-timeline', '.home-timeline', {
  attach: function(context, settings, behavior) {
    // Conteneur principal de la timeline pour cette instance du comportement.
    var holder = jQuery(this);

    // Année courante (ex. 2026), utilisée pour trouver l'année la plus récente affichable.
    var currentYear = new Date().getFullYear();

    // Récupère toutes les années présentes dans les éléments de la barre de timeline.
    // Chaque élément .home-timeline__year porte un data-year.
    var years = holder.find('.home-timeline__year').map(function() {
      return jQuery(this).data('year');
    }).get();

    // Récupère les années associées à chaque slide du carrousel principal.
    var slides = holder.find('.js-home-timeline-slides [data-year]').map(function() {
      return jQuery(this).data('year');
    }).get()

    // Trouve l'année la plus récente qui ne dépasse pas l'année courante.
    // Exemple : si on a 2018, 2020, 2028 et qu'on est en 2026, on garde 2020.
    var mostRecentYear = Math.max.apply(null, years.filter(function(year) {
      return year <= currentYear;
    }));

    // Index de la dernière slide qui correspond à cette année récente
    // (utile si plusieurs slides partagent la même année).
    var indexRecentSlide = slides.lastIndexOf(mostRecentYear);
    // Index de l’élément d’année correspondant dans la barre.
    var indexRecentYear = years.indexOf(mostRecentYear);

    // Slider principal contenant les contenus de la timeline.
    var slider = holder.find(".js-home-timeline-slides");
    // Slider secondaire représentant la barre d’années (navigation).
    var sliderBar = holder.find(".home-timeline__bar");

    // Mapping "année -> indices de slides" pour le slider principal.
    // Permet de savoir combien de slides partagent la même année
    // et quel est l’index de la slide courante dans ce groupe.
    var slidesByYear = {};
    slider.children('[data-year]').each(function(slideIndex) {
      var $yearWrapper = jQuery(this);
      var yearRaw = $yearWrapper.data('year');
      if (typeof yearRaw === 'undefined' || yearRaw === null) {
        return;
      }
      // Clé string pour éviter les écarts number vs string (jQuery .data()).
      var year = String(yearRaw);
      if (!slidesByYear[year]) {
        slidesByYear[year] = [];
      }
      var indexWithinYear = slidesByYear[year].length;
      slidesByYear[year].push(slideIndex);
      // On stocke sur le wrapper de slide sa position dans l’année
      // pour pouvoir colorer le bon dot plus tard.
      $yearWrapper.attr('data-year-index-within', indexWithinYear);
    });

    // Mapping "année -> bullet de la barre"
    // et mise en place des dots sous chaque année avec plusieurs slides.
    var yearBulletsMap = {};
    sliderBar.find('.home-timeline__bar-bullet').each(function() {
      var $bullet = jQuery(this);
      var $yearEl = $bullet.find('.home-timeline__year');
      var yearRaw = $yearEl.data('year');

      if (typeof yearRaw === 'undefined' || yearRaw === null) {
        return;
      }

      var year = String(yearRaw);
      yearBulletsMap[year] = $bullet;

      var slidesForYear = slidesByYear[year] || [];

      // Si cette année possède plusieurs slides, on crée/ajuste les dots.
      if (slidesForYear.length > 1) {
        // Marque le slide de la barre comme "année avec plusieurs événements"
        // pour pouvoir adapter le style du dot principal (pseudo-élément :before) via le CSS.
        $bullet.closest('.slick-slide').addClass('has-multiple-year');

        var $dotsContainer = $bullet.find('.home-timeline__dots');
        if (!$dotsContainer.length) {
          // Les dots supplémentaires sont créés mais initialement masqués.
          // Ils ne seront visibles que lorsque l’année sera active dans le slider.
          $dotsContainer = jQuery('<div class="home-timeline__dots is-hidden" aria-hidden="true"></div>').appendTo($bullet);
        } else {
          $dotsContainer.attr('aria-hidden', 'true').addClass('is-hidden');
        }

        var existingDots = $dotsContainer.find('.home-timeline__dot');
        var neededDots = slidesForYear.length;

        // Ajoute des dots manquants.
        if (existingDots.length < neededDots) {
          for (var i = existingDots.length; i < neededDots; i++) {
            $dotsContainer.append('<span class="home-timeline__dot"></span>');
          }
        }

        // Supprime les dots en trop si jamais le template en a généré plus.
        if (existingDots.length > neededDots) {
          existingDots.slice(neededDots).remove();
        }
      }
    });

    // Met à jour l'état des dots, des années actives et
    // filtre les slides affichées pour ne montrer que celles de l'année courante.
    var updateYearDotsForSlide = function(slickInstance, currentIndex) {
      // TOUJOURS en premier : masquer les dots et retirer .is-same-year de TOUTES les slides.
      // Cela garantit que les slides d'une année précédente ne restent pas visibles,
      // même si la fonction fait un return prématuré plus bas.
      sliderBar.find('.home-timeline__dots').addClass('is-hidden');
      if (slickInstance && slickInstance.$slides) {
        slickInstance.$slides.removeClass('is-same-year');
      }

      if (!slickInstance || typeof currentIndex === 'undefined') {
        return;
      }

      var $currentSlide = slickInstance.$slides && slickInstance.$slides.eq(currentIndex);
      if (!$currentSlide || !$currentSlide.length) {
        return;
      }

      var $yearWrapper = $currentSlide.find('[data-year]').first();
      var yearRaw = $yearWrapper.data('year');

      if (typeof yearRaw === 'undefined' || yearRaw === null) {
        return;
      }

      var year = String(yearRaw);

      var yearIndexWithin = parseInt($yearWrapper.attr('data-year-index-within'), 10);
      if (isNaN(yearIndexWithin)) {
        yearIndexWithin = 0;
      }

      // Rend visibles toutes les slides de la même année que la slide courante.
      var slidesForYear = slidesByYear[year] || [];
      if (slickInstance.$slides) {
        for (var i = 0; i < slidesForYear.length; i++) {
          slickInstance.$slides.eq(slidesForYear[i]).addClass('is-same-year');
        }
      }

      var $bullet = yearBulletsMap[year];
      if (!$bullet || !$bullet.length) {
        return;
      }

      // Marque l'année active (bullet + slide Slick de la frise) pour le style au chargement et en navigation.
      sliderBar.find('.home-timeline__bar-bullet').removeClass('is-year-active');
      sliderBar.find('.slick-slide').removeClass('is-year-active');
      $bullet.addClass('is-year-active');
      $bullet.closest('.slick-slide').addClass('is-year-active');

      // Met à jour les dots : un seul doit être "actif" (rempli) pour la slide courante.
      var $dotsContainer = $bullet.find('.home-timeline__dots');
      if (!$dotsContainer.length) {
        return;
      }

      var $dots = $dotsContainer.find('.home-timeline__dot');
      if (!$dots.length) {
        return;
      }

      // Les dots supplémentaires ne s’affichent que lorsque l’année est active dans le slider.
      // Les autres années avec plusieurs slides restent sans leurs dots visibles.
      $dotsContainer.removeClass('is-hidden');

      $dots.removeClass('home-timeline__dot--active');
      if (yearIndexWithin >= 0 && yearIndexWithin < $dots.length) {
        jQuery($dots.get(yearIndexWithin)).addClass('home-timeline__dot--active');
      }

    };

    // Fonction utilitaire pour corriger aria-hidden sur les slides actives.
    // Objectif : seules les slides visibles dans le viewport du slider
    // doivent être exposées aux lecteurs d'écran (aria-hidden="false").
    var updateAriaHidden = function(sliderElement) {
      var activeCount = 0;
      sliderElement.find('.slick-slide').each(function() {
        var $slide = jQuery(this);
        if ($slide.hasClass('slick-active')) {
          $slide.attr('aria-hidden', 'false');
          activeCount++;
        } else {
          $slide.attr('aria-hidden', 'true');
        }
      });
    };

    // Fonction appelée à l'initialisation de Slick pour :
    // - calculer le nombre de slides pertinentes pour les flèches,
    // - surcharger plusieurs méthodes internes de Slick (setSlideClasses, buildArrows, etc.),
    // - réinitialiser correctement le slider avec ces nouveaux comportements.
    var updatedSlickInit = function (event, slick) {
      slick.arrowsToShow = typeof slick.options.arrowsToShow === 'number'
        ? slick.options.arrowsToShow
        : slick.options.slidesToShow;
      var currentSlide = slick.options.initialSlide;

      // Corrige aria-hidden dès l'initialisation en fonction des slides actives.
      updateAriaHidden(jQuery(event.target));

      // On mémorise certaines fonctions d'origine de Slick
      // pour pouvoir les appeler dans nos surcharges si besoin.
      var setDimensions = slick.setDimensions;
      var originalSetSlideClasses = slick.setSlideClasses;

      jQuery.extend(true, slick, {
        // Surcharge de la fonction de Slick qui gère les classes d'état des slides.
        // Ici on force une logique plus robuste pour :
        // - les slides actives,
        // - la slide centrale (centerMode),
        // - les attributs aria-hidden.
        setSlideClasses: function(index) {
          var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

          // Toujours utiliser notre propre logique car la fonction originale ne fonctionne pas correctement
          allSlides = _.$slider.find('.slick-slide');

          // Retirer toutes les classes actives
          allSlides.removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');

          // Ajouter slick-current à la slide courante
          if (_.$slides && _.$slides.eq(index).length) {
            _.$slides.eq(index).addClass('slick-current');
          }

          // Ajouter slick-active selon le mode
          if (_.options.centerMode === true) {
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            // Calculer les indices de début et de fin
            var startIndex = Math.max(0, index - centerOffset + evenCoef);
            var endIndex = Math.min(_.slideCount, index + centerOffset + 1);


            // Si on est proche du début ou de la fin, ajuster
            if (index < centerOffset) {
              // Proche du début
              startIndex = 0;
              endIndex = Math.min(_.slideCount, _.options.slidesToShow);
            } else if (index > (_.slideCount - 1) - centerOffset) {
              // Proche de la fin
              startIndex = Math.max(0, _.slideCount - _.options.slidesToShow);
              endIndex = _.slideCount;
            }

            // Ajouter les classes aux slides actives
            _.$slides.slice(startIndex, endIndex)
              .addClass('slick-active')
              .attr('aria-hidden', 'false');

            if (_.$slides && _.$slides.eq(index).length) {
              _.$slides.eq(index).addClass('slick-center');
            }
          } else {
            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
              var endIndex = index + _.options.slidesToShow;
              _.$slides.slice(index, endIndex)
                .addClass('slick-active')
                .attr('aria-hidden', 'false');
            } else if (allSlides.length <= _.options.slidesToShow) {
              allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            }
          }

          // Vérifier le résultat
          allSlides = _.$slider.find('.slick-slide');
          var activeSlides = allSlides.filter('.slick-active');
          var inactiveSlides = allSlides.not('.slick-active');

          activeSlides.attr('aria-hidden', 'false');
          inactiveSlides.attr('aria-hidden', 'true');
        },
        buildArrows: function() {

          var _ = this;

          // Création / affichage des flèches si l’option arrows est activée.
          if (_.options.arrows === true ) {
            holder.removeClass('no-arrows');

            _.$prevArrow = jQuery(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = jQuery(_.options.nextArrow).addClass('slick-arrow');

            // Si le nombre de slides dépasse le nombre d'éléments pertinents pour les flèches,
            // on affiche et active les flèches.
            if( _.slideCount > _.arrowsToShow ) {

              _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
              _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

              if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.prependTo(_.options.appendArrows);
              }

              if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.appendTo(_.options.appendArrows);
              }

              if (_.options.infinite !== true) {
                _.$prevArrow
                  .addClass('slick-disabled')
                  .attr('aria-disabled', 'true');
              }

            } else {
              // Pas assez de slides pour justifier des flèches :
              // on les masque et on les rend inaccessibles au clavier.
              holder.addClass('no-arrows');

              _.$prevArrow.add( _.$nextArrow )

                .addClass('slick-hidden')
                .attr({
                  'aria-disabled': 'true',
                  'tabindex': '-1'
                });

            }

          }

        },
        // Gestion de l'action "changer de slide" déclenchée par les flèches ou les puces.
        changeSlide: function(event, dontAnimate) {
          var _ = this,
            $target = jQuery(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

          // Cas particulier : si on est sur la barre des années,
          // on utilise les flèches pour piloter directement le slider principal,
          // afin d'avancer / reculer d'UNE slide de contenu à la fois.
          if (_.$slider && _.$slider.hasClass('home-timeline__bar')) {
            if (event.data && event.data.message === 'previous') {
              // Une slide de contenu vers la gauche
              slider.slick('slickPrev');
              return;
            }
            if (event.data && event.data.message === 'next') {
              // Une slide de contenu vers la droite
              slider.slick('slickNext');
              return;
            }
          }

          // If target is a link, prevent default action.
          if($target.is('a')) {
            event.preventDefault();
          }

          // If target is not the <li> element (ie: a child), find the <li>.
          if(!$target.is('li')) {
            $target = $target.closest('li');
          }

          unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
          indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
          switch (event.data.message) {

            case 'previous':
              // On force un déplacement d'une seule slide vers l'arrière,
              // pour ne pas "sauter" plusieurs slides quand il y en a beaucoup.
              slideOffset = _.options.slidesToScroll;
              if (_.slideCount > _.arrowsToShow) {
                _.slideHandler(_.checkNavigable(_.currentSlide - slideOffset), false, dontAnimate);
              }
              break;

            case 'next':
              // Même logique : une seule slide vers l'avant par clic sur la flèche.
              slideOffset = _.options.slidesToScroll;
              if (_.slideCount > _.arrowsToShow) {
                _.slideHandler(_.checkNavigable(_.currentSlide + slideOffset), false, dontAnimate);
              }
              break;

            case 'index':
              var index = event.data.index === 0 ? 0 :
                event.data.index || $target.index() * _.options.slidesToScroll;

              _.slideHandler(_.checkNavigable(index), false, dontAnimate);
              $target.children().trigger('focus');
              break;

            default:
              return;
          }

        },
        slideHandler: function(index, sync, dontAnimate) {

          var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget, currentYear, targetIndex;
          sync = sync || false;

          if (_.animating === true && _.options.waitForAnimate === true) {
            return;
          }

          if (_.options.fade === true && _.currentSlide === index) {
            return;
          }

          if (sync === false) {
            _.asNavFor(_.checkNavigable(index));
          }

          targetSlide = index;
          targetLeft = _.getLeft(targetSlide);
          slideLeft = _.getLeft(_.currentSlide);

                _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

          if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
              targetSlide = _.currentSlide;
              if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                _.animateSlide(slideLeft, function() {
                  _.postSlide(targetSlide);
                });
              } else {
                _.postSlide(targetSlide);
              }
            }
            return;
          } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
              targetSlide = _.currentSlide;
              if (dontAnimate !== true && _.slideCount > _.arrowsToShow) {
                _.animateSlide(slideLeft, function() {
                  _.postSlide(targetSlide);
                });
              } else {
                _.postSlide(targetSlide);
              }
            }
            return;
          }

          if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
          }

          if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
              animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
              animSlide = _.slideCount + targetSlide;
            }
          } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
              animSlide = 0;
            } else {
              animSlide = targetSlide - _.slideCount;
            }
          } else {
            animSlide = targetSlide;
          }

          _.animating = true;

          _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

          oldSlide = _.currentSlide;
          _.currentSlide = animSlide;

          _.setSlideClasses(_.currentSlide);
          // Corriger aria-hidden après setSlideClasses
          updateAriaHidden(_.$slider);
          if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
              currentYear = _.$slides.eq(_.currentSlide).find('[data-year]').data('year');
              targetIndex = navTarget.$slides.find('[data-year="' + currentYear + '"]').closest('.slick-slide').data('slickIndex');
              if (typeof targetIndex === 'undefined') {
                targetIndex = _.currentSlide;
              }
              navTarget.setSlideClasses(targetIndex);
              // Corriger aria-hidden après setSlideClasses sur le navTarget
              updateAriaHidden(navTarget.$slider);
            }

          }

          _.updateDots();
          _.updateArrows();

          if (_.options.fade === true) {
            if (dontAnimate !== true) {

              _.fadeSlideOut(oldSlide);

              _.fadeSlide(animSlide, function() {
                _.postSlide(animSlide);
              });

            } else {
              _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
          }
          if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function() {
              _.postSlide(animSlide);
            });
          } else {
            _.postSlide(animSlide);
          }

        },
        // Synchronisation d'un slider avec un autre (asNavFor),
        // en se basant sur la même année data-year pour garder les deux alignés.
        asNavFor: function(index) {

          var _ = this,
            asNavFor = _.getNavTarget(),
            currentYear, targetIndex;

          if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
              var target = jQuery(this).slick('getSlick');
              if(!target.unslicked) {
                currentYear = _.$slides.eq(index).find('[data-year]').data('year');
                targetIndex = target.$slides.find('[data-year="' + currentYear + '"]').closest('.slick-slide').data('slickIndex');
                if (typeof targetIndex === 'undefined') {
                  targetIndex = index;
                }
                target.slideHandler(targetIndex, true);
              }
            });
          }

        },
        // Ajout des événements sur les flèches (clic + clavier)
        // uniquement si elles sont pertinentes pour le nombre de slides.
        initArrowEvents: function() {
          var _ = this;

          if (_.options.arrows === true && _.slideCount > _.arrowsToShow) {
            _.$prevArrow
              .off('click.slick')
              .on('click.slick', {
                message: 'previous'
              }, _.changeSlide);
            _.$nextArrow
              .off('click.slick')
              .on('click.slick', {
                message: 'next'
              }, _.changeSlide);

            if (_.options.accessibility === true) {
              _.$prevArrow.on('keydown.slick', _.keyHandler);
              _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
          }

        },
        // Gestion de la sélection d'une slide dans un slider de navigation
        // (par exemple clic sur une année dans la barre).
        selectHandler: function(event) {

          var _ = this;

          var targetElement =
            jQuery(event.target).is('.slick-slide') ?
              jQuery(event.target) :
              jQuery(event.target).parents('.slick-slide');

          var index = parseInt(targetElement.attr('data-slick-index'));

          if (!index) index = 0;

          // Si le clic vient de la frise des années, on pilote directement
          // le slider principal pour aller à l'année cliquée.
          if (_.$slider && _.$slider.hasClass('home-timeline__bar')) {
            var clickedYearRaw = targetElement.find('.home-timeline__year').data('year');
            if (typeof clickedYearRaw === 'undefined' || clickedYearRaw === null) {
              clickedYearRaw = jQuery(event.target).closest('.home-timeline__bar-bullet').find('.home-timeline__year').data('year');
            }

            if (typeof clickedYearRaw !== 'undefined' && clickedYearRaw !== null) {
              var clickedYearKey = String(clickedYearRaw);
              if (slidesByYear[clickedYearKey] && slidesByYear[clickedYearKey].length) {
                slider.slick('slickGoTo', slidesByYear[clickedYearKey][0]);
                return;
              }
            }
          }

          if (_.slideCount <= _.arrowsToShow) {

            _.slideHandler(index, false, false);
            return;

          }

          _.slideHandler(index);

        },
        // Initialisation de l'UI : on décide ici de montrer ou non
        // les flèches et les points en fonction des options et du nombre de slides.
        initUI: function() {

          var _ = this;

          if (_.options.arrows === true && _.slideCount > _.arrowsToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

          }

          if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

          }

        },
        // Recalcule la configuration du slider (par exemple après un resize)
        // en conservant au maximum la slide courante.
        refresh: function (initializing) {
          var _ = this, currentSlide;

          _.arrowsToShow = typeof _.options.arrowsToShow === 'number'
            ? _.options.arrowsToShow
            : _.options.slidesToShow;
          var currentSlide = slick.currentSlide;
          // in non-infinite sliders, we don't want to go past the
          // last visible index.
          if( !_.options.infinite) {
            _.currentSlide = _.checkNavigable(_.currentSlide);
          }

          // if less slides than to show, go to start.
          if ( _.slideCount <= _.arrowsToShow ) {
            _.currentSlide = 0;

          }

          currentSlide = _.currentSlide;

          _.destroy(true);

          jQuery.extend(_, _.initials, { currentSlide: currentSlide });

          _.init();

          if( !initializing ) {

            _.changeSlide({
              data: {
                message: 'index',
                index: currentSlide
              }
            }, false);

          }
        },
        // Met à jour l'état (activé / désactivé) des flèches en fonction
        // de la position courante dans le slider.
        updateArrows: function() {

          var _ = this,
            centerOffset;

          centerOffset = Math.floor(_.arrowsToShow / 2);

          if ( _.options.arrows === true &&
            _.slideCount > _.arrowsToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

              _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
              _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.arrowsToShow && _.options.centerMode === false) {

              _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
              _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

              _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
              _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

          }

        },
        // Surcharge de setDimensions pour gérer un mode
        // où la largeur des slides est calculée sur mesure (customSlideWidth).
        setDimensions: function () {
          var _ = this, slidesToShow, $container, blockMargin;
          setDimensions = jQuery.proxy(setDimensions, _);
          if (typeof _.options.customSlideWidth === 'boolean' && _.options.customSlideWidth === true) {
            slidesToShow = _.slideCount > _.arrowsToShow ? _.options.slidesToShow : _.slideCount;
            _.slideWidth = Math.ceil(_.$list.width() / slidesToShow);
            if (typeof _.options.minWidthSlide === 'number' && _.slideWidth < _.options.minWidthSlide) {
              _.slideWidth = _.options.minWidthSlide;
            }
            var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
            _.$slideTrack.width(Math.ceil((_.slideWidth * slidesToShow)));
            if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
          }
          else {
            setDimensions();
          }
          _.$slideTrack.css({'--slide-width': _.slideWidth + 'px'});
        },
        // Calcule la position (left ou top) du slideTrack en fonction de l'index demandé,
        // en tenant compte des options Slick : infinite, centerMode, variableWidth, rtl, etc.
        getLeft: function(slideIndex) {

          var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef,
            slidesShowed;

          _.slideOffset = 0;
          verticalHeight = _.$slides.first().outerHeight(true);
          if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
              _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
              coef = -1

              if (_.options.vertical === true && _.options.centerMode === true) {
                if (_.options.slidesToShow === 2) {
                  coef = -1.5;
                } else if (_.options.slidesToShow === 1) {
                  coef = -2
                }
              }
              verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
              if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                if (slideIndex > _.slideCount) {
                  _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                  verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                } else {
                  _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                  verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                }
              }
            }
          } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
              _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
              verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
          }

          if (_.slideCount <= _.arrowsToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
          }
          slidesShowed = _.options.slidesToShow < _.slideCount ? _.options.slidesToShow : _.slideCount;

          if (_.options.centerMode === true && _.slideCount <= _.arrowsToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(slidesShowed)) / 2) - ((_.slideWidth * _.slideCount) / 2);
          } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
          } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(slidesShowed / 2);
          }
          if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;

          } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
          }

          if (_.options.variableWidth === true) {
            if (_.slideCount <= _.arrowsToShow || _.options.infinite === false) {
              targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
              targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
              if (targetSlide[0]) {
                targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
              } else {
                targetLeft =  0;
              }
            } else {
              targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
              if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
              } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
              }

              if (_.options.rtl === true) {
                if (targetSlide[0]) {
                  targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                  targetLeft =  0;
                }
              } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;

              }
              targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
          }
          return targetLeft;

        }
      });
      // On rebinde certaines méthodes sur l’instance Slick,
      // puis on détruit et réinitialise le slider avec les nouvelles surcharges.
      slick.changeSlide = jQuery.proxy(slick.changeSlide, slick);
      slick.slideHandler = jQuery.proxy(slick.slideHandler, slick);
      slick.selectHandler = jQuery.proxy(slick.selectHandler, slick);
      slick.destroy(true);
      jQuery.extend(slick, slick.initials, { currentSlide: currentSlide });
      slick.init();
      var $targetSlider = jQuery(event.target);
      if ($targetSlider.hasClass('home-timeline__bar')) {
        slick.$slides && slick.$slides.each(function() {
          var $slide = jQuery(this);
          var $yearEl = $slide.find('.home-timeline__year[data-year]');
          var yearRaw = $yearEl.data('year');
          if (typeof yearRaw === 'undefined' || yearRaw === null) {
            return;
          }
          var slidesForYear = slidesByYear[String(yearRaw)] || [];
          if (slidesForYear.length > 1) {
            $slide.addClass('has-multiple-year');
          } else {
            $slide.removeClass('has-multiple-year');
          }
        });
      }
    }
    // Lors de l'initialisation de chaque slider, on exécute updatedSlickInit
    // pour injecter nos surcharges et correctifs.
    slider.on('init', updatedSlickInit);
    sliderBar.on('init', updatedSlickInit);

    // Initialisation du slider principal qui affiche les contenus de la timeline.
    // On s'appuie maintenant uniquement sur Slick pour n'afficher
    // qu'une seule slide à la fois (slidesToShow: 1).
    slider.slick({
      centerMode: true,
      centerPadding: "163",
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: indexRecentSlide,
      infinite: false,
      draggable: true,
      asNavFor: sliderBar,
      arrows: false,
      speed: 500,
      variableWidth: true,
      centerBigger: true,
      cssEase: 'ease-in-out',
      centeredPX: jQuery(window).width() > 768 ? 163 : 0,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            variableWidth: true
          },
        },
      ]
    });

    // Corrige aria-hidden sur les slides actives après chaque changement de slide
    // pour garder le carrousel lisible pour les lecteurs d’écran.
    slider.on('afterChange', function(event, slick, currentSlide) {
      updateAriaHidden(slider);
      updateYearDotsForSlide(slick, currentSlide);
    });

    // Initialise correctement aria-hidden et l'état des dots au chargement du slider principal.
    slider.on('init', function(event, slick) {
      updateAriaHidden(slider);
      updateYearDotsForSlide(slick, slick.currentSlide || 0);
    });

    // En mode multi-slides d'une même année :
    // clic sur une slide latérale (visible mais non active) => la rendre active.
    holder
      .off('click.timelineSideSlideJump')
      .on('click.timelineSideSlideJump', '.js-home-timeline-slides .slick-slide.is-same-year:not(.slick-active) .slide', function(e) {
        var $targetSlide = jQuery(e.currentTarget).closest('.slick-slide');
        var targetIndex = parseInt($targetSlide.attr('data-slick-index'), 10);

        if (isNaN(targetIndex) || targetIndex < 0) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        slider.slick('slickGoTo', targetIndex);
      });

    // Initialisation de la barre d'années (slider secondaire de navigation).
    sliderBar.slick({
      centerMode: true,
      dots: false,
      arrows: true,
      asNavFor: slider,
      infinite: false,
      draggable: true,
      speed: 300,
      slidesToShow: 7,
      arrowsToShow: 4,
      minWidthSlide: 78,
      slidesToScroll: 1,
      initialSlide: indexRecentYear,
      customSlideWidth: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            arrowsToShow: 1,
          }
        },
      ]
    });

    // Après init des deux sliders (asNavFor, re-init éventuelle), réapplique l'état année active :
    // garantit .is-year-active au premier affichage même si le premier `init` du principal était trop tôt.
    window.setTimeout(function() {
      try {
        var mainSlick = slider.slick('getSlick');
        if (mainSlick) {
          updateYearDotsForSlide(mainSlick, mainSlick.currentSlide);
        }
      } catch (e) {
        // Slider non initialisé : ignorer
      }
    }, 0);

    // Clic explicite sur la frise :
    // - clic sur l'année/bullet : va à la première slide de l'année
    // - clic sur un petit dot : va à la slide correspondante dans l'année
    // On passe par une délégation d'événement pour couvrir tous les cas de clic.
    holder
      .off('click.timelineYearJump')
      .on('click.timelineYearJump', '.home-timeline__bar-bullet, .home-timeline__year, .home-timeline__dot', function(e) {
        var $target = jQuery(e.target);
        var $bullet = $target.closest('.home-timeline__bar-bullet');
        if (!$bullet.length) {
          return;
        }

        var clickedYearRaw = $bullet.find('.home-timeline__year').data('year');
        if (typeof clickedYearRaw === 'undefined' || clickedYearRaw === null) {
          return;
        }

        var clickedYear = String(clickedYearRaw);
        if (!slidesByYear[clickedYear] || !slidesByYear[clickedYear].length) {
          return;
        }

        var targetSlideIndex = slidesByYear[clickedYear][0];

        // Si on clique un petit dot, on cible la slide exacte de cette année.
        if ($target.hasClass('home-timeline__dot')) {
          var dotIndex = $target.index();
          if (dotIndex >= 0 && dotIndex < slidesByYear[clickedYear].length) {
            targetSlideIndex = slidesByYear[clickedYear][dotIndex];
          }
        }

        e.preventDefault();
        e.stopPropagation();
        slider.slick('slickGoTo', targetSlideIndex);
      });

    // Corrige aria-hidden pour les slides de la barre après chaque changement,
    // ce qui garantit que seule l'année "active" reste exposée au lecteur d'écran.
    sliderBar.on('afterChange', function(event, slick, currentSlide) {
      updateAriaHidden(sliderBar);
      // S'assure que les dots supplémentaires sont aussi mis à jour
      // même lorsque la navigation se fait via la barre.
      var mainSlick = slider.slick('getSlick');
      updateYearDotsForSlide(mainSlick, mainSlick.currentSlide || 0);
    });

    // Initialise aria-hidden pour la barre d’années au premier rendu.
    sliderBar.on('init', function(event, slick) {
      updateAriaHidden(sliderBar);
      var mainSlick = slider.slick('getSlick');
      updateYearDotsForSlide(mainSlick, mainSlick.currentSlide || 0);
    });

    // ──────────────────────────────────────────────────
    // Lightbox accessible pour les slides de la timeline
    // ──────────────────────────────────────────────────

    var lightboxId = 'home-timeline-lightbox';

    if (!jQuery('#' + lightboxId).length) {
      var lightboxHtml =
        '<div class="home-timeline-lightbox" id="' + lightboxId + '" role="dialog" aria-modal="true" aria-labelledby="' + lightboxId + '-title" hidden>' +
          '<div class="home-timeline-lightbox__overlay"></div>' +
          '<div class="home-timeline-lightbox__content">' +
            '<div class="home-timeline-lightbox__header">' +
              '<span class="home-timeline-lightbox__year"></span>' +
              '<button class="home-timeline-lightbox__close" type="button" aria-label="Fermer la fen\u00eatre">' +
                '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
                  '<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
            '<div class="home-timeline-lightbox__image"></div>' +
            '<div class="home-timeline-lightbox__body">' +
              '<h3 class="home-timeline-lightbox__title" id="' + lightboxId + '-title"></h3>' +
              '<div class="home-timeline-lightbox__description"></div>' +
            '</div>' +
          '</div>' +
        '</div>';
      jQuery('body').append(lightboxHtml);
    }

    var $lightbox = jQuery('#' + lightboxId);

    var openTimelineLightbox = function($slide) {
      var $img = $slide.find('.image-item img').first();
      var imgSrc = ($img.length && ($img[0].currentSrc || $img.attr('src'))) || '';
      var imgAlt = $img.attr('alt') || '';
      var year = $slide.closest('[data-year]').data('year') || '';
      var title = $slide.find('.slide__title').text().trim();
      var description = $slide.find('.slide__description').html() || '';

      $lightbox.find('.home-timeline-lightbox__year').text(year);
      $lightbox.find('.home-timeline-lightbox__title').text(title);
      $lightbox.find('.home-timeline-lightbox__description').html(description);

      var $imgContainer = $lightbox.find('.home-timeline-lightbox__image');
      $imgContainer.empty();
      if (imgSrc) {
        $imgContainer.append(jQuery('<img>').attr({ src: imgSrc, alt: imgAlt }));
      }

      $lightbox.data('trigger', $slide);
      $lightbox.removeAttr('hidden');
      $lightbox[0].offsetHeight;
      $lightbox.addClass('is-open');
      jQuery('html').addClass('home-timeline-lightbox-open');

      $lightbox.find('.home-timeline-lightbox__close').focus();

      jQuery(document).on('keydown.timelineLightbox', function(e) {
        if (e.key === 'Escape') {
          closeTimelineLightbox();
          return;
        }
        if (e.key === 'Tab') {
          var $focusable = $lightbox.find('button:visible, a[href]:visible, [tabindex]:not([tabindex="-1"]):visible');
          var $first = $focusable.first();
          var $last = $focusable.last();
          if (e.shiftKey && document.activeElement === $first[0]) {
            e.preventDefault();
            $last.focus();
          } else if (!e.shiftKey && document.activeElement === $last[0]) {
            e.preventDefault();
            $first.focus();
          }
        }
      });
    };

    var closeTimelineLightbox = function() {
      $lightbox.removeClass('is-open');
      jQuery('html').removeClass('home-timeline-lightbox-open');
      jQuery(document).off('keydown.timelineLightbox');

      setTimeout(function() {
        $lightbox.attr('hidden', '');
      }, 300);

      var $trigger = $lightbox.data('trigger');
      if ($trigger && $trigger.length) {
        $trigger.focus();
        $lightbox.removeData('trigger');
      }
    };

    holder.on('click', '.slick-current .slide', function(e) {
      // Le slide est un <button> : n'ignorer que les liens imbriqués.
      if (jQuery(e.target).closest('a').length) {
        return;
      }
      e.preventDefault();
      openTimelineLightbox(jQuery(this));
    });

    $lightbox.off('click.timelineLightbox').on('click.timelineLightbox', '.home-timeline-lightbox__close', closeTimelineLightbox);
    $lightbox.off('click.timelineLightboxOverlay').on('click.timelineLightboxOverlay', '.home-timeline-lightbox__overlay', closeTimelineLightbox);

    var updateSlideA11y = function() {
      holder.find('.slide').removeAttr('role tabindex aria-label');
      var $currentSlide = holder.find('.slick-current .slide');
      holder.find('.slide').not($currentSlide).attr('tabindex', '-1');
      if ($currentSlide.length) {
        var slideTitle = $currentSlide.find('.slide__title').text().trim();
        $currentSlide.attr('aria-label', 'Voir le d\u00e9tail : ' + slideTitle);
        $currentSlide.removeAttr('tabindex');
      }
    };

    slider.on('afterChange', updateSlideA11y);
    updateSlideA11y();
  },

  // Méthode requise par l'API de comportements, appelée lors du détachement du comportement.
  // Ici, aucun nettoyage spécifique n'est nécessaire.
  detach: function(context, settings) {}
});
